module.exports = __webpack_public_path__ + "img/quickFunImg02.ae59c833.png";